<template>
  <div>
    <SettingsPageLayout>
      <DetailForm
        v-if="loaded"
        title="PandaDoc"
        description="As part of the onboarding process, Humaniz.io requires some specific information to be able to implement the onboarding process. The PandaDoc Broker Template Id is necessary for automatically creating the ICA Agreement for a new agent."
        action="Save"
        hidecancel="true"
        @handle-action="updateTeam"
      >
        <TextInput
          label="PandaDoc ICA Template Id"
          placeholder="2pj8vF2sxmUrUBv8oTtaz4"
          :model-value="team.icaTemplateId"
          @update:model-value="value => (team.icaTemplateId = value)"
        />
      </DetailForm>
    </SettingsPageLayout>
  </div>
</template>

<script>
import SettingsPageLayout from '../../layouts/SettingsPageLayout/index.vue';
import DetailForm from '../../shared/DetailForm.vue';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

export default {
  components: {
    SettingsPageLayout,
    DetailForm,
  },
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      team: {
        id: '',
        icaTemplateId: '',
      },
      loaded: false,
    };
  },
  mounted() {
    this.getTeam();
  },
  methods: {
    getTeam() {
      const self = this;
      this.loadingSpinnerStore.showLoadingSpinner();
      fetch('/api/team')
        .then(response => {
          this.loadingSpinnerStore.hideLoadingSpinner();
          return response.json();
        })
        .then(data => {
          self.team.id = data.record.id;
          self.team.icaTemplateId = data.record.ica_template_id;
          self.loaded = true;
        });
    },
    updateTeam() {
      const self = this;
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      fetch('/api/team', {
        method: 'PUT',
        body: JSON.stringify({
          ica_template_id: self.team.icaTemplateId,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          this.loadingSpinnerStore.hideLocalLoadingSpinner();
          if (data.status != 'error') {
            toast.success('Onboarding settings updated', {
              action: { label: 'Dismiss' },
              description:
                'Your Onboarding settings were successfully updated.  Use the button below to dismiss this alert.',
            });
          } else {
            toast.error('Onboarding settings update error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
  },
};
</script>
